<template>
  <section class="avantages">

    <!-- Titre centré -->
    <div class="section-header">
      <h2 class="section-title">
        Avantages
        <span class="section-title__underline" aria-hidden="true"></span>
      </h2>
    </div>

    <!-- Contenu : liste gauche + photos droite -->
    <div class="avantages__body"> 

      <!-- Liste des 4 avantages -->
      <ul class="avantages__list">
        <li
          v-for="item in avantages"
          :key="item.title"
          class="avantage-item"
        >
          <div class="avantage-item__icon">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="avantage-item__text">
            <h3 class="avantage-item__title">{{ item.title }}</h3>
            <p class="avantage-item__desc">{{ item.desc }}</p>
          </div>
        </li>
      </ul>

      <!-- Photo -->
      <div class="avantages__photos" aria-hidden="true">
        <div class="photo-stack">
          <div class="photo-card">
            <img src="@/assets/img/ggtttt.png" alt="" />
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'AvantagesSection',

  data() {
    return {
      avantages: [
        {
          title: 'Rapide et Transparent',
          desc: "Transferts et conversions en devises traités dans des délais optimisés avec des taux, frais et montant reçu connus à l'avance.",
          img: require('@/assets/img/av (1).png'),
        },
        {
          title: 'Accessible',
          desc: 'Accédez facilement aux devises pour vos paiements internationaux. Une solution pensée pour être accessible à tous.',
          img: require('@/assets/img/av (5).png'),
        },
        {
          title: 'Simple',
          desc: 'Moins de documents exigés que dans les circuits bancaires classiques (DPI, etc.), ce qui simplifie le processus.',
          img: require('@/assets/img/av (4).png'),
        },
        {
          title: 'Accompagné',
          desc: 'Un expert Nolido FX vous guide à chaque étape. Les opérations sont traitées via des partenaires financiers agréés.',
          img: require('@/assets/img/av (3).png'),
        },
      ],
    }
  },
}
</script>

<style scoped>
/* ════════════════════════════════════════════════
   TOKENS
════════════════════════════════════════════════ */
.avantages {
  --font:          'Sora', 'DM Sans', system-ui, sans-serif;
  --color-text:    #1a1a1a;
  --color-muted:   #6b6b6b;
  --color-border:  #e4e0d8;
  --color-accent:  #c8952b;
  --color-bg-icon: #f2ede6;
}

/* ════════════════════════════════════════════════
   TITRE
════════════════════════════════════════════════ */
.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  position: relative;
  display: inline-block;
  margin: 0;
  font-family: var(--font);
  font-size: clamp(1.8rem, 3.5vw, 2.4rem);
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.02em;
  padding-bottom: 10px;
}

.section-title__underline {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 55%;
  height: 3.5px;
  background: var(--color-accent);
  border-radius: 2px;
}

/* ════════════════════════════════════════════════
   LAYOUT PRINCIPAL
════════════════════════════════════════════════ */
.avantages {
  padding: 72px 50px 80px;
}

.avantages__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px 60px;
  align-items: center;
  max-width: 960px;
  margin: 0 auto;
}

/* ════════════════════════════════════════════════
   LISTE AVANTAGES
════════════════════════════════════════════════ */
.avantages__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.avantage-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.avantage-item__icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--color-bg-icon);
  border: 1.5px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.avantage-item__icon img {
  width: 60%;
  height: 60%;
  object-fit: contain;
}

.avantage-item__text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.avantage-item__title {
  margin: 0;
  font-family: var(--font);
  font-size: 0.97rem;
  font-weight: 700;
  color: var(--color-text);
}

.avantage-item__desc {
  margin: 0;
  font-family: var(--font);
  font-size: 0.83rem;
  font-weight: 400;
  color: var(--color-muted);
  line-height: 1.6;
}

/* ════════════════════════════════════════════════
   PHOTOS EMPILÉES
════════════════════════════════════════════════ */
.avantages__photos {
  display: flex;
  justify-content: center;
  align-items: center;
}

.photo-stack {
  position: relative;
  width: 320px;
  height: 400px;
}

.photo-card {
  width: 100%;
  height: 100%;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: none;
}

.photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Tablet (≤ 900px)
════════════════════════════════════════════════ */
@media (max-width: 900px) {
  .avantages {
    padding-left: 24px;
    padding-right: 24px;
  }

  .avantages__body {
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .avantages__photos {
    order: -1;
  }

  .photo-stack {
    width: 280px;
    height: 350px;
  }
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Mobile (≤ 600px)
════════════════════════════════════════════════ */
@media (max-width: 600px) {
  .avantages {
    padding: 48px 16px 56px;
  }

  .photo-stack {
    width: 240px;
    height: 300px;
  }
}
</style>
